<template>
  <div class="Width100P" v-show="displayed">
    <frame-header
      v-on:iframe-closed="iframeClosed"
      :currentNodeId="currentNodeId"
      v-on:iframe-minimized="iframeMinimized"
    ></frame-header>
    <loader :isLoading="loading"></loader>
    <iframe allowfullscreen="true" :src="src" ref="iframe"></iframe>
  </div>
</template>

<script>
import connectToChild from "penpal/lib/connectToChild";
import portalAPI from "../../services/portalService";
import StorageService from "../../services/storageService";
import MessageValidator from "../../services/messageValidator";
import FrameHeader from "./../viewMode/FrameHeader.vue";
import Loader from "./../viewMode/Loader.vue";
//import _ from "lodash";

let pAPI = new portalAPI();
let messageValidator = new MessageValidator();
let storageService = new StorageService();

export default {
  name: "appComponent",

  components: {
    FrameHeader,
    Loader
  },

  props: [
    "src",
    "msg",
    "displayed",
    "currentNodeId",
    "nodeUniqueId",
    "sentMessage",
    "appType",
    "checkIfMessageBelongsToApp"
  ],
  data() {
    let that = this;

    return {
      iframeConnection: null,
      objStore: [],
      messageGroup: [],
      //TODO::Exposed methods need to be extracted as a service
      exposedMethods: {
        create_object(
          iframeid,
          messageType,
          obj_localReference,
          message,
          returnMode = false
        ) {
          let isValid = messageValidator.validateMessage(
            that.currentNodeId,
            messageType,
            message
          );
          if (typeof isValid == "string") {
            // error message
            alert(isValid);
          }
          let messageGroupName;
          // TODO::Refactor by Extrating this condition
          if (message.length > 1) {
            //It is a group of messages add it if it isn't exist

            messageGroupName = message
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map(a => a.name)
              .join(", ");
            if(messageGroupName) messageGroupName= messageGroupName.substring(0,100)
            // if group already exist don't add it again
            if (
              that.objStore.filter(m => m.messageGroupName == messageGroupName)
                .length > 1
            )
              return {
                local_ref: obj_localReference,
                portal_ref: iframeid,
                type: messageType,
                details: message
              };
          }
          let msg = {
            dataObject: JSON.stringify(message),
            sessionId: that.$session.id(),
            nodeId: iframeid, /// TODO /// should be taken from the opened component not from the msg
            messageType: messageType,
            localRef: obj_localReference,
            messageGroupName: messageGroupName
          };


            pAPI.saveMessage(msg).then(res => {
              //ToDo:
              if (returnMode) {
                //console.log("EMIT EVENT")
                message[0].msgId = res.data[0].message.id;
                that.$emit("message-returned", message);
              } else {
                res.data.forEach(messageItem => {
                  /* 
                    -if this msg guid doesn't exist add it 
                    -if exist 
                      - exist outside group --> delete it and add with the group
                      - exist inside another group --> add it with the group
                  */

                  let existMsgIndex = that.objStore.findIndex(
                    m => m.messageGuid == messageItem.message.message_guid
                  );

                  if ( existMsgIndex >= 0 && !that.objStore[existMsgIndex].messageGroupId ) {
                    that.objStore.splice(existMsgIndex, 1);
                    existMsgIndex = -1;
                  }


                  if (
                    existMsgIndex < 0 ||
                    (existMsgIndex >= 0 &&
                      (messageItem.group !=null &&
                       that.objStore[existMsgIndex].messageGroupId !=
                        messageItem.group.group_guid
                      )
                    )
                  ) {
                    let messageData = JSON.parse(
                      messageItem.message.data_object
                    );
                    if (that.checkIfMessageBelongsToApp(messageType)) {
                      that.objStore.push({
                        ...messageData,
                        msgId: messageItem.message.id,
                        nodeUniqueId: iframeid,
                        localRef: obj_localReference,
                        messageType: messageType,
                        messageGuid: messageItem.message.message_guid,
                        messageGroupId: messageItem.group
                          ? messageItem.group.group_guid
                          : null,
                        messageGroupName: messageItem.group
                          ? messageItem.group.group_name
                          : null
                      });
                    } else {
                      that.$toastr.w(
                        "Your action has been recognized but none of your applications accept this type."
                      );
                    }
                  } else {
                    if(messageItem.group!=null){
                    that.objStore[existMsgIndex].messageGroupId =
                      messageItem.group.group_guid;
                    that.objStore[existMsgIndex].messageGroupName =
                      messageItem.group.group_name;}
                  }
                });
                that.$emit("object-store-updated", that.objStore, iframeid);
              }
            });


          return {
            local_ref: obj_localReference,
            portal_ref: iframeid,
            type: messageType,
            details: message
          };
        },
        notify_logout(){
          that.$store.dispatch('notifyAppLogoutAction');
        },
        forward_object(iframeid, obj_portalReference, destination, forward) {         
          if (forward) {
            let destinationUrls = destination.split('?sec_added_to_url=');

            let destinationNode = that.$store.state.userNodes.filter(
              n => n.node_apprv == destinationUrls[0]
            )[0];


            //if current node has children search on them
            let currentNode = that.$store.state.userNodes.filter(n=>n.id == that.currentNodeId)[0];

            if(currentNode && currentNode.children.length >0 && !destinationNode){
              destinationNode = currentNode.children.filter(c=> c.node_apprv == destinationUrls[0])[0];
            }



            if(destinationNode){
              let forwardMessages = [];
              forwardMessages = obj_portalReference.map(m => ({
                ...m,
                name: destinationNode.name,
                messageName: destinationNode.name
              }));
              let msg = {
                dataObject: JSON.stringify(forwardMessages),
                sessionId: that.$session.id(),
                nodeId: iframeid, /// TODO /// should be taken from the opened component not from the msg
                messageType: "forwardMessageType",
                localRef: obj_portalReference,
                messageGroupName: "ForwardMessageGroup"
              };


              pAPI.saveMessage(msg).then(res => {
                forwardMessages = forwardMessages.map(m => ({
                  ...m,
                  msgId: res.data[0].message.id
                }));
                
                
                let secAddedToUrl = '';
                
                if(destinationUrls.length > 1){
                  secAddedToUrl = destinationUrls[1];
                  secAddedToUrl = secAddedToUrl.split(destinationNode.url)[1];

                  if(secAddedToUrl.startsWith('?')){
                    secAddedToUrl = secAddedToUrl.substring(1);
                  }
                } 
                
                that.$emit(
                  "message-selected",
                    forwardMessages,
                    destinationNode.id,
                    true,
                    secAddedToUrl 
                  );
              });
            }
            else{
              // an error message should be displayed says you are not allowed to open this application
            }
          }
          return "";
        },

        return_object() {
          //iframeid,obj_PortalReference){
          var val = Math.random();
          alert(val);
          return val;
        },

        load_object(iframeid, obj_localreference, obj_portalreference) {
          return {
            local_ref: obj_localreference,
            portal_ref: obj_portalreference,
            value: that.getObjDetails(obj_portalreference)
          };
        },
        close_me(){
          that.iframeClosed(true);
        }
      },
      loading: false
    };
  },
  watch: {
    sentMessage: {
      handler: function(val){//}, oldVal) {
        let that = this;
        that.iframeConnection.promise.then(clientIframe => {
          //console.log("sentMessage " + that.src);
          clientIframe.acceptReturnedObject(that.nodeUniqueId, val);
          if (!Array.isArray(val)) val = [val];

            pAPI.saveMessageReciever(
              {
                receiverNodeId: that.currentNodeId,
                messages: val
              }
            );
          });
      },
      deep: true
    },
    logoutNotification(newVal){
      //the client application should be logged out
      if (newVal){
        this.iframeConnection.promise.then(clientIframe => {
          if(typeof clientIframe.logout === 'function'){
          clientIframe.logout();
          }
        });
      }
    }
  },
  computed: {
    logoutNotification : function(){
      return this.$store.getters.logoutInitiated;
    }
  },
  methods: {
    cycleCompletion(cycleCompletedTime){
      let that = this;
        that.iframeConnection.promise.then(clientIframe => {
          //console.log("cycleCompletedTime Promise: "+that.nodeUniqueId)
          clientIframe.notifyCycleCompletion(that.nodeUniqueId, cycleCompletedTime);
        });
    },
    iframeMinimized() {
      this.$emit("iframe-minimized");
    },

    iframeClosed(ignoreConfirmClose = false) {
      let that = this;
      //if current node has children search on them
      let currentNode = that.$store.state.userNodes.find(n=>n.id == that.currentNodeId);
  
      if(!currentNode){
        currentNode = that.$store.state.userNodes.filter(
          (x) => x.children.length>0 && x.children.find(c=>c.id == that.currentNodeId)
        );
      }


      if(currentNode.confirm_close && !ignoreConfirmClose){
        that.iframeConnection.promise.then((clientIframe) => {
          clientIframe.handleClose();
        });

      }else{
        this.$emit("iframe-closed", this.nodeUniqueId, this.currentNodeId);// it is preferable to use Vuex instead of event emitter in multiple component
        if(this.iframeConnection){
          this.iframeConnection.destroy();// error displayed in the console if the child did not open
        }
      }
    },

    initiateIframeConnection(intiObj) {
      let that = this;

      if (that.msg) {
        that.iframeConnection.promise.then((clientIframe) => {
          clientIframe
            .initializeForDave(that.nodeUniqueId, intiObj)
            .then(function () {
              clientIframe.acceptReturnedObject(that.nodeUniqueId, that.msg);

              pAPI.saveMessageReciever({
                receiverNodeId: that.currentNodeId,
                messages: that.msg,
              });
            });

          that.loading = false;
        });
      } else {
        that.iframeConnection.promise.then((clientIframe) => {
          clientIframe.initializeForDave(that.nodeUniqueId, intiObj);
          that.loading = false;
        });
      }
    },
  },
  mounted() {
    let iframe = this.$refs["iframe"];
    let that = this;
    this.$store.dispatch('registerAppAction');
    if (this.appType && this.appType.toUpperCase() !== "EXTERNAL") {
      that.loading = true;
    }
    that.iframeConnection = connectToChild({
      iframe: iframe,
      iframeUniqueId: that.nodeUniqueId,
      methods: that.exposedMethods
    });
    let intiObj = null;
    let authentication_mode = storageService.get("auth_mode");
    if (that.appType.toUpperCase().indexOf("CROPWISE")>= 0 && authentication_mode === 'cw') {
      that.$AuthService.getToken().then(token=>{
        that.initiateIframeConnection({
          "cropwise_token" :token
        });
      });
    }else{
      that.initiateIframeConnection(intiObj);
    }
    
    document.getElementById("popupContainer").classList.remove("opened");
  },
  destroyed(){
    this.$store.dispatch('deregisterAppAction');
  }
};
</script>

<style>
.Width100P {
  width: 100%;
  position: absolute;
}
iframe {
  background-color: white;
  height:100%;
  width:100%;
  border:0px;
}

.iframe-wrapper{
  position:fixed;
  right:0;
  bottom:0;
  left:80px;
  top:75px;
  -webkit-overflow-scrolling:touch;
}
</style>